import React, { memo } from "react";
import useNotificationCard from "./index.hooks";
import { INotification } from "models/Notification";
import {
  Badge,
  Divider,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";
import moment from "moment";

type NotificationCardProps = {
  notificationData: INotification;
};

const NotificationCard = ({ notificationData }: NotificationCardProps) => {
  const { styles, classes, atomicStyles } = useNotificationCard();

  return (
    <div className={styles.cardRoot}>
      <IconButton disabled className={styles.notificationType} size={"small"}>
        {notificationData.isTest ? "T" : "P"}
      </IconButton>
      <Tooltip title={notificationData.title} enterTouchDelay={1}>
        <Typography
          variant={"h6"}
          color={"primary"}
          noWrap
          style={{ marginTop: "0.5em" }}
        >
          {notificationData.title}
        </Typography>
      </Tooltip>
      <Typography noWrap variant={"body1"} classes={classes.message}>
        {notificationData.description}
      </Typography>
      <div style={{ maxWidth: "100%" }}>
        <Divider variant={"middle"} />
        <div style={{ display: "flex" }}>
          <Typography className={styles.footerTexts} style={{ flexGrow: 1 }}>
            {moment(notificationData.created).fromNow()}
          </Typography>
          <Badge
            badgeContent={`${notificationData.devicesReached} views`}
            color={"primary"}
            className={styles.views}
          />
        </div>
      </div>
    </div>
  );
};

export default memo(NotificationCard);
